import styled, { css } from 'styled-components';

import VideoComponent from 'components/Video/Video';
import { mediaDesktop } from 'utils/styles/responsive';

export const ArticleVideoWrapper = styled.div`
  margin-bottom: 64px;
  grid-column: 1/ -1;

  ${mediaDesktop(css`
    margin-bottom: 96px;
    grid-column: 3/ -3;
  `)}
`;

export const Video = styled(VideoComponent)`
  width: 100%;
`;
